module.exports = __webpack_public_path__ + "img/john.252c8f62.jpg";